export default "__VITE_ASSET__DLZzGGkK__"